<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-data-table 
                    :items="data" 
                    :headers="columns" 
                    disable-pagination 
                    hide-default-footer
                    class="custom-table"
                >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td v-for="(column, index) in columns" :key="index">
                                <template v-if="column.type === 'text'">
                                    {{ item[column.value] }}
                                </template>

                                <template v-else-if="column.type === 'input'">
                                    <v-text-field 
                                        :value="item[column.value]"
                                        type="number"
                                        :rules="[rules.range]"
                                        :min="0"
                                        :max="maxScore"
                                        density="compact"
                                        variant="outlined" 
                                        class="input-box"
                                        :disabled="readonly"
                                        @input="(val) => handleInput(val, item, column.value)"
                                        @keypress="validateKeyPress"
                                    />
                                </template>

                                <template v-else-if="column.type === 'button'">
                                    <custom-button 
                                        v-for="(action, actionIndex) in column.actions" 
                                        :key="actionIndex"
                                        :color="action.color" 
                                        @click="action.handler(item)" 
                                        :icon="action.icon"
                                        size="xs" 
                                        gradient 
                                        fab
                                    />
                                </template>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import CustomButton from '@/components/common/buttons/CustomButton.vue';

export default {
    name: "SimpleTableContent",
    components: {
        CustomButton,
    },
    props: {
        data: {
            type: Array,
            required: true,
            default: () => {
                return [];
            },
        },
        columns: {
            type: Array,
            required: true,
            default: () => {
                return [];
            },
        },
        maxScore: {
            type: Number,
            default: 10,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            rules: {
                range: (v) => {
                    const num = Number(v);
                    return (num >= 0 && num <= this.maxScore) || 
                        `값은 0에서 ${this.maxScore} 사이여야 합니다.`;
                }
            }
        }
    },
    methods: {
        validateKeyPress(event) {
            // 숫자와 백스페이스, 삭제 키만 허용
            const keyCode = event.keyCode;
            const allowedKeys = [8, 46]; // backspace, delete

            if (!allowedKeys.includes(keyCode) && (keyCode < 48 || keyCode > 57)) {
                event.preventDefault();
            }

            // 현재 값 + 새로운 키가 maxScore를 초과하는지 확인
            const currentValue = event.target.value || '';
            const newValue = currentValue + event.key;
            
            if (Number(newValue) > this.maxScore) {
                event.preventDefault();
            }
        },

        handleInput(value, item, field) {
            let numValue = value === '' ? 0 : Number(value);

            // 범위 검증
            if (numValue > this.maxScore) {
                numValue = this.maxScore;
            } else if (numValue < 0) {
                numValue = 0;
            }

            // 정수로 변환
            numValue = Math.floor(numValue);

            // 값 업데이트
            this.$set(item, field, numValue);
            this.emitUpdatedData();
        },

        emitUpdatedData() {
            this.$emit("update-data", [...this.data]);
        }
    },
};
</script>

<style scoped>
.input-box {
    max-width: 100px;
}

/* 숫자 입력 필드의 화살표 버튼 제거 */
.input-box :deep(input[type="number"]) {
    -moz-appearance: textfield;
}

.input-box :deep(input[type="number"]::-webkit-outer-spin-button),
.input-box :deep(input[type="number"]::-webkit-inner-spin-button) {
    -webkit-appearance: none;
    margin: 0;
}
</style>
